import(/* webpackMode: "eager" */ "/workspace/manjappada-landing-web/src/app/gallery/loading.js");
